import { render, staticRenderFns } from "./ConfigureCname.vue?vue&type=template&id=4482af96&scoped=true"
import script from "./ConfigureCname.vue?vue&type=script&lang=js"
export * from "./ConfigureCname.vue?vue&type=script&lang=js"
import style0 from "./ConfigureCname.vue?vue&type=style&index=0&id=4482af96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482af96",
  null
  
)

export default component.exports